import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview } from '../services/plausible';

export function usePlausiblePageview() {
  const location = useLocation();

  useEffect(() => {
    trackPageview();
  }, [location.pathname]);
}